module.exports = __webpack_public_path__ + "03_glasses_black.d3616305.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/03_glasses_black.png
// module id = VG+f
// module chunks = 0